import { GradeScale } from '../../../types/gradeScaleType';

export type GradeValidationErrors = { [key: string]: string };

export const validateGrade = (
  gradeName: string,
  min: string,
  max: string,
  gradeScale: GradeScale,
  isNew: boolean
): GradeValidationErrors => {
  const errors: GradeValidationErrors = {};

  const minVal = Number(min);
  const maxVal = Number(max);

  const rules = [
    {
      field: 'gradeName',
      condition: !gradeName.trim(),
      message: 'Grade name is required'
    },
    {
      field: 'gradeName',
      condition:
        isNew &&
        Object.keys(gradeScale.gradeScaling).includes(gradeName.trim()),
      message: 'Grade name must be unique'
    },
    {
      field: 'min',
      condition: min.trim() === '',
      message: 'Min is required'
    },
    {
      field: 'max',
      condition: max.trim() === '',
      message: 'Max is required'
    },
    {
      field: 'min',
      condition: min.trim() !== '' && isNaN(minVal),
      message: 'Min must be a number'
    },
    {
      field: 'max',
      condition: max.trim() !== '' && isNaN(maxVal),
      message: 'Max must be a number'
    },
    {
      field: 'min',
      condition: !isNaN(minVal) && (minVal < 0 || minVal > 100),
      message: 'Min must be between 0 and 100'
    },
    {
      field: 'max',
      condition: !isNaN(maxVal) && (maxVal < 0 || maxVal > 100),
      message: 'Max must be between 0 and 100'
    },
    {
      field: 'min',
      condition: !isNaN(minVal) && !isNaN(maxVal) && minVal > maxVal,
      message: 'Min cannot be greater than Max'
    },
    {
      field: 'max',
      condition: !isNaN(minVal) && !isNaN(maxVal) && maxVal < minVal,
      message: 'Max cannot be less than Min'
    }
  ];

  rules.forEach(({ field, condition, message }) => {
    if (condition && !errors[field]) {
      errors[field] = message;
    }
  });

  return errors;
};
